import { HStack, Icon, IconProps, Label } from '@medely/ui-kit';
import React from 'react';

export const ApplicationReceivedItem = ({
  text,
  iconName,
  isMobile = false,
}: {
  text: string;
  iconName: IconProps['name'];
  isMobile?: boolean;
}) => {
  return (
    <HStack pb={2} gap={0.5} alignItems="center">
      <Icon
        name={iconName}
        color="text.primary"
        variant="custom"
        iconSize={isMobile ? '16px' : '18px'}
      />
      <Label size={isMobile ? 's' : 'm'}>{text}</Label>
    </HStack>
  );
};
